import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const Docker = () => {
  return (
    <StartInterviewLayout type="docker"/>
  )
}

export default Docker;